module.exports = __webpack_public_path__ + "img/us-ar.9075c930.svg";